import * as Styled from 'components/ToolkitV2/BulletedList/BulletedList.styled';
import type { BulletedListProps } from 'components/ToolkitV2/BulletedList/BulletedList.typed';
import React from 'react';
import { BulletedListItem } from 'components/ToolkitV2/BulletedList/BulletedListItem/BulletedListItem';

export const BulletedList = (props: BulletedListProps) => {
  const { children } = props;
  return (
    <Styled.BulletedList>
      {children.map((text, index) => (
        <BulletedListItem key={index}>{text}</BulletedListItem>
      ))}
    </Styled.BulletedList>
  );
};
